import { c as create_ssr_component, i as is_promise, n as noop, v as validate_component, g as compute_rest_props } from "./ssr.js";
const EditorToolbar_1 = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { confirmLabel = "Save" } = $$props;
  let { canConfirm = true } = $$props;
  if ($$props.confirmLabel === void 0 && $$bindings.confirmLabel && confirmLabel !== void 0)
    $$bindings.confirmLabel(confirmLabel);
  if ($$props.canConfirm === void 0 && $$bindings.canConfirm && canConfirm !== void 0)
    $$bindings.canConfirm(canConfirm);
  return `${function(__value) {
    if (is_promise(__value)) {
      __value.then(null, noop);
      return ``;
    }
    return function(EditorToolbar) {
      return ` ${validate_component(EditorToolbar.default, "EditorToolbar.default").$$render($$result, { confirmLabel, canConfirm }, {}, {})} `;
    }(__value);
  }(import("./EditorControls.js"))}`;
});
const PlainText = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["editable", "content", "multiLine"]);
  let { editable } = $$props;
  let { content } = $$props;
  let { multiLine = false } = $$props;
  if ($$props.editable === void 0 && $$bindings.editable && editable !== void 0)
    $$bindings.editable(editable);
  if ($$props.content === void 0 && $$bindings.content && content !== void 0)
    $$bindings.content(content);
  if ($$props.multiLine === void 0 && $$bindings.multiLine && multiLine !== void 0)
    $$bindings.multiLine(multiLine);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${editable ? `${function(__value) {
      if (is_promise(__value)) {
        __value.then(null, noop);
        return `  <!-- HTML_TAG_START -->${content}<!-- HTML_TAG_END --> `;
      }
      return function(PlainTextEditor) {
        return ` ${validate_component(PlainTextEditor.default, "PlainTextEditor.default").$$render(
          $$result,
          Object.assign({}, { multiLine }, $$restProps, { content }),
          {
            content: ($$value) => {
              content = $$value;
              $$settled = false;
            }
          },
          {}
        )} `;
      }(__value);
    }(import("./PlainTextEditor.js"))}` : ` <!-- HTML_TAG_START -->${content}<!-- HTML_TAG_END -->`}`;
  } while (!$$settled);
  return $$rendered;
});
export {
  EditorToolbar_1 as E,
  PlainText as P
};
